import {
  CompanyAttributes,
  TripAttributes,
  VisitAttributes,
} from "@albatrosdeveloper/ave-models-package";
import { OverlayModule } from "@angular/cdk/overlay";
import { CommonModule } from "@angular/common";
import { Component, OnDestroy, signal } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatCheckbox } from "@angular/material/checkbox";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatDialogModule } from "@angular/material/dialog";
import {
  MatDatepicker,
  MatDatepickerModule,
  MatDatepickerToggle,
} from "@angular/material/datepicker";
import {
  MatAccordion,
  MatExpansionModule,
  MatExpansionPanelHeader,
} from "@angular/material/expansion";
import {
  MatFormField,
  MatFormFieldModule,
  MatLabel,
} from "@angular/material/form-field";
import { MatIcon } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatMenu, MatMenuModule } from "@angular/material/menu";
import { MatProgressBar } from "@angular/material/progress-bar";
import { MatSelectModule } from "@angular/material/select";
import { MatSidenavContainer } from "@angular/material/sidenav";
import { MatSortModule } from "@angular/material/sort";
import { MatTableModule } from "@angular/material/table";
import { NgSelectModule } from "@ng-select/ng-select";
import { NgxMatSelectSearchModule } from "ngx-mat-select-search";
import { IFilterMaterial } from "../../assistant/sales-distribution/interfaces/filter_material.interface";
import { CompanyService } from "../../configuration/company/company.service.service";
import { AgendaViewComponent } from "../agenda-view/agenda-view.component";
import { MonitorRoutesComponent } from "../monitor-routes/monitor-routes.component";
import { OfficeGroupService } from "../../configuration/office-group/office-group.service";
import { SalesOfficeService } from "../../configuration/sales-office/sales-office.service";
import OfficeGroupAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/configurations/office-group/office-group.entity";
import SalesOfficeAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/configurations/sales-office/sales-office.entity";
import { SubRouteService } from "../../routing/sub-routes/sub-route.service";
import { RouteGroupService } from "../../routing/route-group/route-group.service";
import RouteGroupAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/routing/route-group/route-group.entity";
import RouteAttributes from "@albatrosdeveloper/ave-models-package/src/schemas/routing/route/route.entity";
import { PrincipalScreenService } from "./principal-screen.service";
import {
  StatusEnum,
  SubRouteTypeEnum,
} from "@albatrosdeveloper/ave-models-package/lib/enums";
import { TranslocoModule } from "@ngneat/transloco";
import { MatTooltipModule } from "@angular/material/tooltip";
import { getStartAndEndOfDayUTC } from "app/utils/date-utc";
import { OrderTripDate } from "./interfaces/trip.interface";
import { debounceTime, forkJoin, Subject, Subscription, takeUntil } from "rxjs";
import { distinctUntilChanged, skip } from "rxjs/operators";
import { TripDatepickerComponent } from "./trip-picker/trip-datepicker.component";
import { SearchService } from "app/layout/common/search-page/search-page.service";
import { FilterComponent } from "app/common/components/filter/filter.component";
import { FilterSectionComponent } from "app/common/components/filter-section/filter-section.component";
import { IPaginationResult } from "app/common/interfaces";
import { ConfigurationFiltersComponent } from "../../filters/configuration-filters/configuration-filters.component";
import { DatesFiltersComponent } from "../../filters/dates-filters/dates-filters.component";
import { RoutesFiltersComponent } from "../../filters/routes-filters/routes-filters.component";
import { IFilters } from "../../filters/interfaces/filterInterface";
import { ActivatedRoute } from "@angular/router";
import { DateHelper } from "app/utils/date.helper";
import { MatSnackBar } from "@angular/material/snack-bar";
import { HoverMenuDirective } from "@fuse/directives/hover-menu/hover-menu.directive";
import { MapModalComponent } from "app/shared/components/map-modal/map-modal.component";
import { MatDialog } from "@angular/material/dialog";
import { MapModalInputData } from "app/shared/components/map-modal/models/map-modal.interface";
import { MapModalTypeEnum, MonitorDocumentTypeEnum } from "app/shared/components/map-modal/models/map-modal.enum";
import { StatusFiltersComponent } from "../../filters/status-filters/status-filters.component";
import { PinnedTripsService } from "./pinned-trips.service";
import { TripWithPinnedStatus } from "./interfaces/pinned-trips.interface";
import { PinnedTripsConfigModalComponent, PinnedTripsConfigData, PinnedTripsConfigResult } from "./pinned-trips-config-modal/pinned-trips-config-modal.component";

import {
  MatTreeFlatDataSource,
  MatTreeFlattener,
} from "@angular/material/tree";
import { TripStatus } from "app/common/enums/trip-status.enum";

export enum TripFilterOptions {
  PAST = 'Pasados',
  FUTURE = 'Futuros',
}

export enum ViewTypesOptions {
  AGENDA = "Agenda",
  RUTES = "Rutas",
}
export type TripFilterType = `${TripFilterOptions}`;
// Extrae solo los valores como tipo
export type ViewType = `${ViewTypesOptions}`;

export type TripAttributesDataSource =
  IPaginationResult<TripAttributes>["data"][0];

@Component({
  selector: "app-principal-screen",
  standalone: true,
  imports: [
    CommonModule,
    MonitorRoutesComponent,
    MatSidenavContainer,
    MatIcon,
    MatButtonModule,
    NgSelectModule,
    MatDatepickerToggle,
    NgxMatSelectSearchModule,
    FormsModule,
    NgSelectModule,
    MatFormField,
    MatFormFieldModule,
    MatDatepicker,
    MatLabel,
    MatDatepickerModule,
    MatInputModule,
    MatMenu,
    MatMenuModule,
    MatProgressBar,
    MatCardModule,
    MatTableModule,
    MatSortModule,
    MatExpansionModule,
    TranslocoModule,
    MatTableModule,
    ReactiveFormsModule,
    MatSelectModule,
    OverlayModule,
    AgendaViewComponent,
    MatTooltipModule,
    MatExpansionModule,
    TripDatepickerComponent,
    FilterComponent,
    FilterSectionComponent,
    ConfigurationFiltersComponent,
    DatesFiltersComponent,
    RoutesFiltersComponent,
    HoverMenuDirective,
    StatusFiltersComponent,
    MatSlideToggleModule,
    MatDialogModule
  ],
  templateUrl: "./principal-screen.component.html",
  styleUrl: "./principal-screen.component.scss",
})
export class PrincipalScreenComponent implements OnDestroy {

  TripStatus = TripStatus;
  
  isViewMenuOpen = false;
  modeTreeMonitor: "statusTrip" | "functionTrip" | null = null;
  isLoadingTreedata = false;
  ViewTypesOptions = ViewTypesOptions;
  selectedTripStatuses: number[] = [];
  selectedRouteFunction: string[] = [];

  tripStatusOptions = [
    { id: TripStatus.ABIERTO, name: 'Abierto', code: 'TRIP_CREATED' },
    { id: TripStatus.CARGANDO, name: 'Cargando', code: 'TRIP_READY_TO_START' },
    { id: TripStatus.EN_PROCESO, name: 'En proceso', code: 'TRIP_IN_PROCESS' },
    { id: TripStatus.CERRADO, name: 'Cerrado', code: 'TRIP_CLOSED' },
    { id: TripStatus.LIQUIDANDO, name: 'Liquidando', code: 'TRIP_IN_LIQUIDATION' },
    { id: TripStatus.DOC_LIQUIDACION_CREADO, name: 'Doc. liquidación creado', code: 'TRIP_LIQUIDATION_DOC_CREATED' },
    { id: TripStatus.DOC_LIQUIDACION_APROBADO, name: 'Doc. liquidación aprobado', code: 'TRIP_LIQUIDATION_DOC_APPROVED' },
    { id: TripStatus.FINALIZADO, name: 'Finalizado', code: 'TRIP_FINALIZED' },
  ];

  // Funciones de ruta disponibles
  routeFunctionOptions = [
    { code: '07', name: 'PREVENTA' },
    { code: '08', name: 'ENTREGA' }
  ];

  public isShowGrap: boolean = false;

  statusOrders = {
    open: 0,
    pending: 0,
    loading: 0,
    inTransit: 0,
    settlement: 0,
    closed: 0,
  };

  public selectedViewType = signal<ViewType>(ViewTypesOptions.RUTES);

  get viewType() {
    return this.selectedViewType;
  }

  get tripFilterType() {
    return this.selectedTripFilterType;
  }

  setViewType(viewType: ViewType) {
    this.selectedViewType.set(viewType);

    // Consultar datos según el nuevo modo seleccionado
    if (viewType === ViewTypesOptions.AGENDA) {
      // Modo agenda: siempre usar fetchAllWithCount con paginación
      this.fetchAllWithCount(50, 1, null);
    } else if (viewType === ViewTypesOptions.RUTES) {
      // Modo rutas: considerar si está en modo árbol o paginación normal
      if (this.modeTreeMonitor === 'statusTrip' || this.modeTreeMonitor === 'functionTrip') {
        // Modo árbol: usar fetchAllDataForTree
        this.fetchAllDataForTree();
      } else {
        // Modo paginación normal: usar fetchAllWithCount
        this.fetchAllWithCount(50, 1, null);
      }
    }
  }
  setTripFilterType(type: TripFilterOptions): void {
    this.selectedTripFilterType.set(type);

    // Mostrar el datepicker correspondiente
    if (type === TripFilterOptions.PAST) {
      this.showTripDatePicker = 'past';
    } else if (type === TripFilterOptions.FUTURE) {
      this.showTripDatePicker = 'future';
    }
  }

  // Dato busqueda
  search: string;

  // Datos de los viajes api
  public dataSource: TripAttributesDataSource;
  public totalItems = 0;
  typeList: { key: SubRouteTypeEnum; value: string }[] = [];
  // Datos de cards

  uninitiated = {
    value: 0,
    load: 0,
  };

  inProgress = {
    value: 0,
    load: 0,
  };

  fullDelivery = {
    value: 0,
    load: 0,
  };

  liquidated = {
    value: 0,
    load: 0,
  };

  // Datos Filter
  submitted: boolean = false;
  form: FormGroup;
  range: FormGroup;
  companyList: CompanyAttributes[] = [];
  salesOfficeList: SalesOfficeAttributes[] = [];
  officeGroupList: OfficeGroupAttributes[] = [];
  routeList: RouteAttributes[] = [];
  routeGroupList: RouteGroupAttributes[] = [];

  public currentUpdateDocumentRange: {
    dateTimeStart?: Date;
    company?: CompanyAttributes[];
  };

  selectedDate = new Date();
  selectedTripFuture = signal<OrderTripDate>({ days: [], total: 0 });
  selectedTripPast = signal<OrderTripDate>({ days: [], total: 0 });
  isLoadingTripsFuture = signal(false);
  isLoadingTripsPast = signal(false);
  private lastLoadedFutureDate: string | null = null;
  private lastLoadedPastDate: string | null = null;

  private dateSelection$ = new Subject<any>();
  private _onDestroy = new Subject<void>();
  // Debounce para fetchAllWithCount - evitar llamadas simultáneas
  private fetchAllWithCountSubject$ = new Subject<{
    pageSizeCustom: number;
    pageIndexCustom: number;
    sortActiveCustom: any;
    selectedDate?: Date;
    isInitialLoad?: boolean;
  }>();

  //BUSCADOR
  searchSubscription: Subscription;
  interval;
  timeInterval = 60000 * 15;
  showInterval: boolean = false;

  subs: Subscription[] = [];
  tripToFilter: string[] = []
  //Propiedades para button v
  TripFilterOptions = TripFilterOptions;
  isTripMenuOpen: boolean = false;
  public selectedTripFilterType = signal<TripFilterType>(TripFilterOptions.PAST);

  // Propiedades para viajes pineados
  pinnedTripIds: Set<number> = new Set();
  pinnedTrips: TripAttributes[] = [];
  showOnlyPinned: boolean = false;
  isLoadingPinnedTrips: boolean = false;

  // Flag de sincronización para evitar race conditions
  private isInitialLoadComplete: boolean = false;
  private pendingInitialLoad: boolean = false;
  public showTripDatePicker: 'past' | 'future' | null = null;

  searchControl = new FormControl("");
  constructor(
    private readonly companyService: CompanyService,
    private readonly salesOfficeService: SalesOfficeService,
    private readonly officeGroupService: OfficeGroupService,
    private readonly routeService: SubRouteService,
    private readonly routeGroupService: RouteGroupService,
    private readonly tripService: PrincipalScreenService,
    private readonly searchService: SearchService,
    private readonly pinnedTripsService: PinnedTripsService,
    private readonly dialog: MatDialog,
    private fb: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private snackBar: MatSnackBar,
  ) {
    this.range = this.fb.group({
      selectedDate: [null],
      selectedDateEnd: [null],
    });
    const today = new Date();
    //Inicializacion de datos
    this.form = this.fb.group({
      startTrip: [today],
      endTrip: [today],
      modelEnum: [],
      end_startTrip: [],
      end_endTrip: [],
      charge_start: [],
      charge_end: [],
      companyId: [null],
      routeTypeId: [[]],
      salesOfficeGroupId: [[]],
      salesOfficeId: [[]],
      routeGroupId: [[]],
      subRouteId: [[]],
      functionCodes: [],
      multiVehicle: [null],
      multiDevice: [null],
      hasUnifiedLoadDocs: [null],
    });
  }

  public onHandleGraph() {
    this.isShowGrap = !this.isShowGrap;
  }

 
  public onHandleSearch() {
    this.searchSubscription = this.searchService.searchTerm$.pipe(
      skip(1),
      distinctUntilChanged(),
      debounceTime(300)
    ).subscribe(
      (term) => {
        const trimmedTerm = term?.trim()?.toLowerCase() || '';
        this.search = trimmedTerm;


        // Siempre ejecutar fetchAllWithCount - tanto para búsquedas como para limpiar
        this.fetchAllWithCount(50, 1, null);
      }
    );
  }

  compareById = (o1: any, o2: any) => o1 && o2 && o1._id === o2._id;

  // Definición de la función formatZero
  formatZero(value: number): string | number {
    if (value) {
      return value === 0 ? "-" : value.toFixed(2);
    }

    return "";
  }

  ngAfterViewInit() {
    // Verificar si hay tripId en queryParams antes de hacer carga inicial
    const queryParams = this.activatedRoute.snapshot.queryParams;
    const hasTripIdParam = queryParams && queryParams['tripId'];

    // Solo hacer carga inicial si NO hay tripId
    // Si hay tripId, el procesamiento de queryParams se encarga del fetch
    if (!this.isInitialLoadComplete && !hasTripIdParam) {
      this.pendingInitialLoad = true;
      this.fetchAllWithCount(50, 1, null, undefined, true);
    }
  }

  ngOnInit() {
    this.loadInitialState();
    this.loadCompanies();

    this.searchService.clear();
    this.onHandleSearch();

    // Suscripción a los viajes pineados
    this.subs.push(
      this.pinnedTripsService.pinnedTrips$.subscribe(pinnedIds => {
        this.pinnedTripIds = pinnedIds;
        if (pinnedIds.size > 0) {
          this.loadPinnedTrips();
        } else {
          this.pinnedTrips = [];
          if (this.showOnlyPinned) {
            this.showOnlyPinned = false;
            this.pinnedTripsService.setViewMode(false);

            if (this.modeTreeMonitor === 'statusTrip' || this.modeTreeMonitor === 'functionTrip') {
              this.fetchAllDataForTree();
            } else {
              this.fetchAllWithCount(50, 1, null);
            }
          }
        }
      })
    );

    this.subs.push(
      this.activatedRoute.queryParams.subscribe(async (params) => {
        if (params["tripId"]) {
          this.tripToFilter = params["tripId"]
            ? params["tripId"].split(",")
            : [];


          // VALIDACIÓN: Si hay modo "solo pineados", preguntar primero
          if (this.showOnlyPinned) {
            this.pendingInitialLoad = true;
            this.snackBar.open("No se puede buscar por ID de viaje en modo 'Solo pineados, por favor cambia a modo 'Todos'", "Cerrar", { duration: 20000 });
            const continueWithPinned = await this.showTripIdWithPinnedModeAlert();
            if (!continueWithPinned) {
              // Usuario eligió cambiar a modo "todos"
              this.showOnlyPinned = false;
              this.pinnedTripsService.setViewMode(false);
              this.pendingInitialLoad = false;
              this.fetchAllWithCount(50, 1, null);
            }
          } else {
            this.pendingInitialLoad = false;
            this.fetchAllWithCount(50, 1, null);
          }
        }
      })
    );



    this.typeList = Object.entries(SubRouteTypeEnum).map(([key, value]) => ({
      key: key as SubRouteTypeEnum,
      value,
    }));
    this.currentUpdateDocumentRange = {
      dateTimeStart: new Date(),
    };

    this.dateSelection$
      .pipe(debounceTime(500), takeUntil(this._onDestroy))
      .subscribe((event) => {
        this.form.get("startTrip").setValue(event);
        this.range.get("selectedDate").setValue(event);
        this.form.get("endTrip").setValue(event);
        this.fetchAllWithCount(50, 1, null);
      });

    // Configurar debounce interno para fetchAllWithCount
    this.subs.push(
      this.fetchAllWithCountSubject$
        .pipe(
          debounceTime(100),
          takeUntil(this._onDestroy)
        )
        .subscribe((params) => {
          this.executeFetchAllWithCount(
            params.pageSizeCustom,
            params.pageIndexCustom,
            params.sortActiveCustom,
            params.selectedDate,
            params.isInitialLoad || false
          );
        })
    );
  }

  //Aplicar filtros modo árbol
  public handleFilterSearch(): void {
    this.submitted = true;
    if (this.form.valid) {
      if (
        this.modeTreeMonitor === "statusTrip" ||
        this.modeTreeMonitor === "functionTrip"
      ) {
        this.fetchAllDataForTree();
      } else {
        this.fetchAllWithCount(50, 1, null);
      }
    } else {
      this.form.markAllAsTouched();
    }
  }
  public findAllWithCountTree(): void {
    if (this.modeTreeMonitor === "statusTrip") {
      this.fetchAllDataForTree();
    } else {
      this.fetchAllWithCount(50, 1, null);
    }
  }

  //cambios de filtro de estados de viaje
  onTripStatusFilterChange(): void {
    this.fetchAllWithCount(50, 1, null);
  }
  onRouteFunctionFilterChange(): void {
    // Para función de ruta no aplicamos otros filtros, traemos todos los datos
    this.fetchAllWithCount(50, 1, null);
  }

  // format add cero
  private addZero(value: number) {
    return value < 10 ? `0${value}` : value;
  }

  // Filter handle
  // Ofininas
  public onSelectionChangeSalesGroup(): void {
    this.fetchAllSalesOffice();
  }

  // Rutas
  public onSelectionChangeGroupRoutes(): void {
    this.fetchAllRoute();
  }

  // Fetch companies
  private fetchCompanies(): void {
    this.companyService.findToComboBox().subscribe((res) => {
      this.companyList = res.data;
      if (this.companyList.length == 1)
        this.form.get("companyId").setValue(this.companyList[0].id);
    });
  }

  // Fetch Oficina de ventas
  private fetchAllSalesOffice(): void {
    this.salesOfficeService
      .findToComboBoxGroup(this.form.value.salesOfficeGroupId)
      .subscribe({
        next: (res) => {
          this.salesOfficeList = res.data;
        },
        error: (err) => {
          this.snackBar.open(
            err.error.message || "Error al obtener las oficinas de venta.",
            "Cerrar",
            { duration: 5000 }
          );
        },
      });
  }

  // Fetch Grupo de oficina
  private fetchOfficeGroup(): void {
    this.officeGroupService.findToComboBox().subscribe({
      next: (res) => {
        this.officeGroupList = res.data;
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error al obtener el grupo de oficina.",
          "Cerrar",
          { duration: 5000 }
        );
      },
    });
  }

  // Fetch Rutas
  private fetchAllRoute(): void {
    this.routeService
      .findToComboBoxByGroup(this.form.value.routeGroupId)
      .subscribe({
        next: (res) => {
          this.routeList = res.data;
        },
        error: (err) => {
          this.snackBar.open(
            err.error.message || "Error al obtener las rutas.",
            "Cerrar",
            { duration: 5000 }
          );
        },
      });
  }


  private fetchAllWithCount(
    pageSizeCustom: number,
    pageIndexCustom: number,
    sortActiveCustom,
    selectedDate?: Date,
    isInitialLoad: boolean = false
  ): void {
    this.fetchAllWithCountSubject$.next({
      pageSizeCustom,
      pageIndexCustom,
      sortActiveCustom,
      selectedDate,
      isInitialLoad
    });
  }

  private executeFetchAllWithCount(
    pageSizeCustom: number,
    pageIndexCustom: number,
    sortActiveCustom,
    selectedDate?: Date,
    isInitialLoad: boolean = false
  ): void {

    // Control de race conditions: evitar llamadas durante carga inicial
    if (!isInitialLoad && !this.isInitialLoadComplete && this.pendingInitialLoad) {
      return;
    }

    const hasTripToFilterOnLoad = this.tripToFilter.length > 0;

    const sortDirection = "ASC";
    let filter: IFilters;

    if (hasTripToFilterOnLoad) {
      // Solo enviar ordersToFilter cuando hay trips específicos desde la carga inicial
      filter = {
        ordersToFilter: this.tripToFilter
      };
    } else {
      // Enviar todos los filtros normales del formulario
      filter = {
        charge_start: DateHelper.getStartOfDay(this.form.get("charge_start")?.value),
        charge_end: DateHelper.getEndOfDay(this.form.get("charge_end")?.value) ?? DateHelper.getEndOfDay(this.form.get("charge_start")?.value) ?? null,
        startTrip: DateHelper.getStartOfDay(this.form.get("startTrip")?.value),
        endTrip: DateHelper.getEndOfDay(this.form.get("endTrip")?.value) ?? DateHelper.getEndOfDay(this.form.get("startTrip")?.value) ?? null,
        end_startTrip: DateHelper.getStartOfDay(this.form.get("end_startTrip")?.value),
        end_endTrip: DateHelper.getEndOfDay(this.form.get("end_endTrip")?.value) ?? DateHelper.getEndOfDay(this.form.get("end_startTrip")?.value) ?? null,
        companyId: this.form.get("companyId")?.value,
        salesOfficeId: this.form.get("salesOfficeId")?.value,
        salesOfficeGroupId: this.form.get("salesOfficeGroupId")?.value,
        masterUserId: this.form.get("assignedUserId")?.value,
        routeGroupId: this.form.get("routeGroupId")?.value,
        subRouteId: this.form.get("subRouteId")?.value,
        routeTypeId: this.form.get("routeTypeId").value,
        ordersToFilter: null,
        functionNames: this.selectedRouteFunction.length ? this.selectedRouteFunction : null,
        functionCodes: this.form.get("functionCodes")?.value,
        tripStatuses: this.selectedTripStatuses.length ? this.selectedTripStatuses : null,
        multiVehicle: this.form.get("multiVehicle")?.value ?? undefined,
        multiDevice: this.form.get("multiDevice")?.value ?? undefined,
        hasUnifiedLoadDocs: this.form.get("hasUnifiedLoadDocs")?.value,
      };
    }

    this.tripService
      .findAllWithCount(
        {
          currentPage: pageIndexCustom,
          limitPerPage: pageSizeCustom,
          search: this.search,
          sort: sortActiveCustom,
          sortDirection: sortDirection,
        },
        filter,
      )
      .subscribe((data) => {
        const isAgendaMode = selectedDate !== undefined;

        // Si estamos en modo "solo pineados", no actualizar con datos paginados
        if (this.showOnlyPinned) {
          return;
        }

        // Procesar datos según el modo
        if (isAgendaMode && selectedDate) {
          this.processAgendaData(data?.data?.[0], selectedDate);
        } else {
          this.dataSource = data?.data?.[0];
          this.totalItems = this.dataSource?.pageInfo?.total || 0;
          this.calculate(this.dataSource.data);
          this.mergePinnedWithDataSource();
        }

        // Marcar carga inicial como completada
        if (isInitialLoad) {
          this.isInitialLoadComplete = true;
          this.pendingInitialLoad = false;
        }

        // Limpiar tripToFilter después de usarlo para que solo se aplique una vez
        if (hasTripToFilterOnLoad) {
          this.tripToFilter = [];
        }
      });
  }

  /**
   * Process data for agenda mode with date-specific pinned trips filtering
   */
  private processAgendaData(rawData: any, selectedDate: Date): void {
    // Set basic data structure
    this.dataSource = rawData;
    this.totalItems = this.dataSource?.pageInfo?.total || 0;
    this.calculate(this.dataSource?.data || []);

    // If we have pinned trips, apply date filtering for agenda
    if (this.pinnedTripIds.size > 0) {
      // Filter pinned trips by selected date
      const dateFilteredPinnedTrips = this.filterPinnedTripsByDate(this.pinnedTrips, selectedDate);

      // Combine filtered pinned trips with regular data
      if (dateFilteredPinnedTrips.length > 0) {
        const regularData = this.dataSource?.data || [];
        const cleanedRegularData = this.removePinnedFromRegularData(regularData, dateFilteredPinnedTrips);

        // Create combined data with date-filtered pinned trips first
        const combinedData = [...dateFilteredPinnedTrips, ...cleanedRegularData];

        this.dataSource = {
          ...this.dataSource,
          data: combinedData
        };
      }
    }
  }

  /**
   * Filter pinned trips by specific date (for agenda mode)
   */
  private filterPinnedTripsByDate(pinnedTrips: any[], selectedDate: Date): any[] {
    if (!pinnedTrips || pinnedTrips.length === 0) {
      return [];
    }

    return pinnedTrips.filter(trip => {
      // Get trip date from dateTimeStart or startTrip field
      const tripDate = new Date(trip.dateTimeStart || trip.startTrip);
      const selectedDateOnly = new Date(selectedDate);

      // Compare only the date part (ignore time)
      return tripDate.toDateString() === selectedDateOnly.toDateString();
    });
  }

  // Método para cambiar modo árbol
  onChangePointTree(mode: "statusTrip" | "functionTrip" | null): void {
    this.modeTreeMonitor = mode;

    if (mode === 'statusTrip' || mode === 'functionTrip') {
      // Modo árbol: verificar si hay viajes pineados y estamos en modo "solo pineados"
      if (this.showOnlyPinned && this.pinnedTripIds.size === 0) {
        return;
      }
      this.fetchAllDataForTree();
    } else {
      // Modo normal (paginación)
      this.fetchAllWithCount(50, 1, null);
    }
  }

  private fetchAllDataForTree(): void {
    this.isLoadingTreedata = true;

    let filter: IFilters = {
      charge_start: DateHelper.getStartOfDay(
        this.form.get("charge_start")?.value
      ),
      charge_end:
        DateHelper.getEndOfDay(this.form.get("charge_end")?.value) ??
        DateHelper.getEndOfDay(this.form.get("charge_start")?.value) ??
        null,
      startTrip: DateHelper.getStartOfDay(this.form.get("startTrip")?.value),
      endTrip:
        DateHelper.getEndOfDay(this.form.get("endTrip")?.value) ??
        DateHelper.getEndOfDay(this.form.get("startTrip")?.value) ??
        null,
      end_startTrip: DateHelper.getStartOfDay(
        this.form.get("end_startTrip")?.value
      ),
      end_endTrip:
        DateHelper.getEndOfDay(this.form.get("end_endTrip")?.value) ??
        DateHelper.getEndOfDay(this.form.get("end_startTrip")?.value) ??
        null,
      companyId: this.form.get("companyId")?.value,
      salesOfficeId: this.form.get("salesOfficeId")?.value,
      salesOfficeGroupId: this.form.get("salesOfficeGroupId")?.value,
      masterUserId: this.form.get("assignedUserId")?.value,
      routeGroupId: this.form.get("routeGroupId")?.value,
      subRouteId: this.form.get("subRouteId")?.value,
      routeTypeId: this.form.get("routeTypeId").value,
      ordersToFilter: null,
      functionCodes: this.form.get("functionCodes")?.value,
      functionNames: this.selectedRouteFunction.length ? this.selectedRouteFunction : null,
      tripStatuses: this.selectedTripStatuses.length ? this.selectedTripStatuses : null,
      multiVehicle: this.form.get("multiVehicle")?.value ?? undefined,
      multiDevice: this.form.get("multiDevice")?.value ?? undefined,
      hasUnifiedLoadDocs: this.form.get("hasUnifiedLoadDocs")?.value,
    };

    // Strategy: Combine pinned trips with regular data before grouping
    // 1. Make parallel API calls for regular data and pinned trips
    // 2. Remove pinned trips from regular data to avoid duplicates
    // 3. Combine: [...pinnedTrips, ...cleanedRegularTrips]
    // 4. Let monitor-routes handle normal grouping + sorting

    if (this.pinnedTripIds.size > 0) {
      // Parallel API calls
      const regularData$ = this.tripService.findAllForTreeView(filter);
      const pinnedIds = Array.from(this.pinnedTripIds);
      const pinnedData$ = this.tripService.findTripsByIds(pinnedIds);

      // Combine both API responses
      forkJoin({
        regular: regularData$,
        pinned: pinnedData$
      }).subscribe({
        next: ({ regular, pinned }) => {
          const rawRegularData = regular?.data?.[0]?.data || [];
          const pinnedTrips = pinned?.data?.[0]?.data || [];

          if (this.showOnlyPinned) {
            // Only show pinned trips
            const combinedData = {
              data: pinnedTrips,
              pageInfo: { total: pinnedTrips.length, page: 1, pageSize: 50 }
            };
            this.dataSource = combinedData;
          } else {
            // Combine pinned trips with regular data (removing duplicates)
            const cleanedRegularData = this.removePinnedFromRegularData(rawRegularData, pinnedTrips);
            const combinedTrips = [...pinnedTrips, ...cleanedRegularData];

            const combinedData = {
              data: combinedTrips,
              pageInfo: { total: combinedTrips.length, page: 1, pageSize: 50 }
            };
            this.dataSource = combinedData;
          }

          this.isLoadingTreedata = false;
        },
        error: (error) => {
          this.snackBar.open('Error al cargar datos', 'Cerrar', { duration: 3000 });
          this.isLoadingTreedata = false;
        }
      });
    } else {
      // No pinned trips, load regular data only
      this.tripService.findAllForTreeView(filter)
        .subscribe({
          next: (treeResponse) => {
            const rawTreeData = treeResponse?.data?.[0] || {
              data: [],
              pageInfo: { total: treeResponse?.data?.[0]?.data?.length || 0, page: 1, pageSize: 50 }
            };
            this.dataSource = rawTreeData;
            this.isLoadingTreedata = false;
          },
          error: (error) => {
            this.snackBar.open(
              error.error.message || "Error al cargar datos para el árbol",
              "Cerrar",
              { duration: 5000 }
            );
            this.isLoadingTreedata = false;
          }
        });
    }
  }

  private getSortFieldByTrip() {
    return "dateTimeStart";
  }

  clearFilters(): void {
    this.form.reset({
      selectedDate: null,
      selectedDateEnd: null,
      companyId: null,
      startTrip: null,
      endTrip: null,
      routeTypeId: [],
      salesOfficeGroupId: [],
      salesOfficeId: [],
      routeGroupId: [],
      subRouteId: [],
      hasUnifiedLoadDocs: null,
    });
    this.search = "";
    // TODO: this is not an arrya
    // @ts-ignore
    this.dataSource = [];
    this.selectedTripStatuses = [];
    this.selectedRouteFunction = [];    // this.fetchAllWithCount(10, 1, null);
  }

  public calculate(data: TripAttributes[]) {
    data.forEach((trip) => {
      switch (true) {
        case [StatusEnum.TRIP_CREATED].includes(trip.statusTripId):
          this.statusOrders.open++;
          break;
        case [StatusEnum.TRIP_READY_TO_START].includes(trip.statusTripId):
          this.statusOrders.pending++;
          break;
        case [StatusEnum.TRIP_IN_PROCESS].includes(trip.statusTripId):
          this.statusOrders.inTransit++;
          break;
        case [
          StatusEnum.TRIP_IN_LIQUIDATION,
          StatusEnum.TRIP_LIQUIDATION_DOC_APPROVED,
          StatusEnum.TRIP_LIQUIDATION_DOC_CREATED,
        ].includes(trip.statusTripId):
          this.statusOrders.settlement++;
          break;
        case [StatusEnum.TRIP_CLOSED, StatusEnum.TRIP_FINALIZED].includes(
          trip.statusTripId
        ):
          this.statusOrders.closed++;
          break;
        default:
          break;
      }
    });
  }

  onMenuOpened(): void {
    this.getTripsFuture();
    this.getTripsPast();
  }

  onModeChanged(isFuture: boolean): void {
    if (isFuture) {
      this.getTripsFuture();
    } else {
      this.getTripsPast();
    }
  }

  onDateFutureSelected(event: any) {
    this.selectedDate = event;
    this.selectedTripFilterType.set(TripFilterOptions.FUTURE);
    this.showTripDatePicker = 'future';
    this.onDateSelected(event);
  }

  onDatePastSelected(event: any) {
    this.selectedDate = event;
    this.selectedTripFilterType.set(TripFilterOptions.PAST);
    this.showTripDatePicker = 'past';
    this.onDateSelected(event);
  }

  onDateSelected(event: any) {
    this.dateSelection$.next(event);
  }

  getTripsFuture() {
    const currentDate = this.form.get("startTrip")?.value?.toISOString?.() ?? String(this.form.get("startTrip")?.value);
    if (currentDate === this.lastLoadedFutureDate && this.selectedTripFuture().days.length > 0) return;
    if (this.isLoadingTripsFuture()) return;
    this.isLoadingTripsFuture.set(true);

    const pageIndexCustom: number = 1;
    const pageSizeCustom: number = 100;
    const sortActiveCustom = null;

    const dateToUse = this.form.get("startTrip")?.value || new Date();

    const selectedDate = new Date(dateToUse);

    const startDate = new Date(selectedDate);
    startDate.setDate(startDate.getDate() + 1);

    const endDate = new Date(selectedDate);
    endDate.setMonth(endDate.getMonth() + 3);

    const date = {
      start: DateHelper.getStartOfDay(startDate),
      end: DateHelper.getEndOfDay(endDate),
    };

    const sortDirection = "ASC";
    this.tripService
      .findTripFuture(
        {
          currentPage: pageIndexCustom,
          limitPerPage: pageSizeCustom,
          search: this.search,
          sort: sortActiveCustom,
          sortDirection: sortDirection,
        },
        date,
        this.form.value.subRouteId,
        this.form.value.companyId,
        this.form.value.salesOfficeId,
        this.form.value.routeTypeId
      )
      .subscribe({
        next: (res) => {
          if (res.data) {
            this.selectedTripFuture.set({
              days: res?.data?.data,
              total: res.data?.pageInfo?.[0]?.total ?? 0,
            });
            this.lastLoadedFutureDate = currentDate;
          }
          this.isLoadingTripsFuture.set(false);
        },
        error: () => {
          this.isLoadingTripsFuture.set(false);
        }
      });
  }

  getTripsPast() {
    const currentDate = this.form.get("startTrip")?.value?.toISOString?.() ?? String(this.form.get("startTrip")?.value);
    if (currentDate === this.lastLoadedPastDate && this.selectedTripPast().days.length > 0) return;
    if (this.isLoadingTripsPast()) return;
    this.isLoadingTripsPast.set(true);

    const pageIndexCustom: number = 1;
    const pageSizeCustom: number = 100;
    const sortActiveCustom = null;

    const dateToUse = this.form.get("startTrip")?.value || new Date();

    const endDate = new Date(dateToUse);

    const startDate = new Date(dateToUse);
    startDate.setMonth(startDate.getMonth() - 3);

    const date = {
      start: DateHelper.getStartOfDay(startDate),
      end: DateHelper.getEndOfDay(endDate),
    };

    const sortDirection = "ASC";
    this.tripService
      .findTripFuture(
        {
          currentPage: pageIndexCustom,
          limitPerPage: pageSizeCustom,
          search: this.search,
          sort: sortActiveCustom,
          sortDirection: sortDirection,
        },
        date,
        this.form.value.subRouteId,
        this.form.value.companyId,
        this.form.value.salesOfficeId,
        this.form.value.routeTypeId
      )
      .subscribe({
        next: (res) => {
          if (res.data) {
            this.selectedTripPast.set({
              days: res?.data?.data,
              total: res.data?.pageInfo?.[0]?.total ?? 0,
            });
            this.lastLoadedPastDate = currentDate;
          }
          this.isLoadingTripsPast.set(false);
        },
        error: () => {
          this.isLoadingTripsPast.set(false);
        }
      });
  }

  isToday(): boolean {
    const today = new Date().toDateString();
    const startDate = new Date(this.form.value.startTrip);
    const endDate = new Date(this.form.value.endTrip);

    if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
      return false;
    }

    return startDate.toDateString() === today && endDate.toDateString() === today;
  }

  //region Pedidos mapa
  openMap(data) {
    this.dialog.open(MapModalComponent, {
      width: '90%',
      data: data
    });
  }

  openModalTrip(): void {
    const data: MapModalInputData = {
      type: MapModalTypeEnum.VISIT_ROUTE_GLOBAL_FILTER,
      tripId: null,
      element: null,
      document: MonitorDocumentTypeEnum.NONE,
      groupDocuments: [],
      map: {
        displayMode: 'drawer',
        captions: { title: 'Viajes' }
      }
    }

    this.openMap(data)
  }
  //#endregion

  ngOnDestroy() {
    this.searchService.clear();
    this.searchSubscription.unsubscribe();
    this.subs.forEach(sub => sub.unsubscribe());
    this._onDestroy.next();
    this._onDestroy.complete();
  }

  // Métodos para manejar viajes pineados

  /**
   * Carga el estado inicial desde localStorage
   */
  private loadInitialState(): void {
    try {
      const viewState = this.pinnedTripsService.loadViewState();
      this.showOnlyPinned = viewState.showOnlyPinned;


      // Si está en modo "solo pineados" pero no hay viajes pineados, cambiar a "todos"
      if (this.showOnlyPinned && (!viewState.tripIds || viewState.tripIds.length === 0)) {
        this.showOnlyPinned = false;
        this.pinnedTripsService.setViewMode(false);
      }

    } catch (error) {
      this.showOnlyPinned = false;
    }
  }

  /**
   * Carga la lista de compañías para pasarla al componente hijo
   * Esto evita race conditions entre la carga de companies y trips
   */
  private loadCompanies(): void {
    this.companyService.findToComboBox().subscribe({
      next: (res) => {
        this.companyList = res.data;
      },
      error: (err) => {
        this.snackBar.open('Error al cargar compañías', 'Cerrar', { duration: 3000 });
      }
    });
  }

  /**
   * Muestra alerta al usuario cuando entra con modo solo pineados
   */
  private showPinnedModeAlert(): void {
    const dialogRef = this.dialog.open(PinnedTripsConfigModalComponent, {
      width: '95%',
      maxWidth: '600px',
      data: {
        currentMode: 'pinned-only',
        pinnedCount: this.pinnedTripIds.size,
        showModeQuestion: true // Flag para mostrar pregunta específica al entrar
      }
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.mode === 'all') {
        // Usuario eligió cambiar a mostrar todos
        this.showOnlyPinned = false;
        this.pinnedTripsService.setViewMode(false);
      }
      // Si no hay resultado o eligió mantener solo pineados, no hacer nada
    });
  }

  /**
   * Muestra alerta cuando hay tripId en queryParams con modo solo pineados activo
   * Retorna Promise que resuelve true si se mantiene modo pineados, false si cambia a todos
   */
  private showTripIdWithPinnedModeAlert(): Promise<boolean> {
    return new Promise((resolve) => {
      const dialogRef = this.dialog.open(PinnedTripsConfigModalComponent, {
        width: '95%',
        maxWidth: '600px',
        disableClose: true, // Importante: usuario debe decidir
        data: {
          currentMode: 'pinned-only',
          pinnedCount: this.pinnedTripIds.size,
          hasTripIdFilter: true,
          message: 'Estás buscando un viaje específico pero tienes el modo "Solo viajes pineados" activo. ¿Deseas cambiar al modo que muestra todos los viajes para ver el resultado?'
        }
      });

      dialogRef.afterClosed().subscribe((result) => {
        if (result && result.mode === 'all') {
          // Usuario eligió cambiar a modo todos
          resolve(false);
        } else {
          // Mantener modo solo pineados
          resolve(true);
        }
      });
    });
  }



  /**
   * Remove pinned trips from regular data to avoid duplicates
   */
  private removePinnedFromRegularData(regularData: any[], pinnedTrips: any[]): any[] {
    if (!pinnedTrips || pinnedTrips.length === 0) {
      return regularData;
    }

    const pinnedIds = new Set(pinnedTrips.map(trip => trip.id));
    return regularData.filter(trip => !pinnedIds.has(trip.id));
  }

  /**
   * Simple method to return tree data without pinned trips logic
   */
  private mergeTreeDataWithPinnedTrips(treeData: any, pinnedTrips: any[]): any {
    return treeData;
  }



  /**
   * Simple method to return tree data without filtering logic
   */
  private filterTreeDataForPinnedTrips(treeData: any): any {
    return treeData;
  }

  /**
   * Carga los viajes pineados desde el servicio
   */
  private loadPinnedTrips(): void {
    const pinnedIds = Array.from(this.pinnedTripIds);

    if (pinnedIds.length === 0) {
      this.pinnedTrips = [];
      return;
    }

    this.isLoadingPinnedTrips = true;
    this.tripService.findTripsByIds(pinnedIds).subscribe({
      next: (response) => {
        this.pinnedTrips = response?.data?.[0]?.data || [];
        this.isLoadingPinnedTrips = false;
        this.mergePinnedWithDataSource();
      },
      error: (error) => {
        this.isLoadingPinnedTrips = false;
        this.snackBar.open('Error al cargar viajes pineados', 'Cerrar', { duration: 3000 });
      }
    });
  }

  /**
   * Alterna el estado pineado de un viaje
   */
  public togglePinTrip(tripId: number): void {
    const wasPinned = this.pinnedTripsService.isTripPinned(tripId);

    if (!wasPinned && this.pinnedTripsService.hasReachedLimit()) {
      return;
    }

    const success = this.pinnedTripsService.togglePinTrip(tripId);
  }

  /**
   * Muestra solo los viajes pineados
   */
  private showOnlyPinnedTrips(): void {

    this.dataSource = {
      data: this.pinnedTrips,
      pageInfo: {
        total: this.pinnedTrips.length,
        page: 1,
        pageSize: this.pinnedTrips.length || 50
      }
    };
    this.totalItems = this.pinnedTrips.length;
    this.calculate(this.pinnedTrips);
  }

  /**
   * Muestra todos los viajes con los pineados al inicio
   */
  private showAllTripsWithPinned(): void {
    if (!this.dataSource) {
      return;
    }

    const paginatedData = this.dataSource?.data || [];
    const pinnedIdsSet = new Set(this.pinnedTrips.map(trip => trip.id));
    const filteredPaginatedData = paginatedData.filter(trip => !pinnedIdsSet.has(trip.id));
    const mergedData = [...this.pinnedTrips, ...filteredPaginatedData];

    this.dataSource = {
      ...this.dataSource,
      data: mergedData,
      pageInfo: {
        ...this.dataSource.pageInfo,
        total: this.dataSource.pageInfo?.total || 0
      }
    };
  }


  private mergePinnedWithDataSource() {
    if (this.showOnlyPinned) {
      this.showOnlyPinnedTrips();
    } else {
      this.showAllTripsWithPinned();
    }
  }

  /**
   * Verifica si un viaje está pineado
   */
  public isTripPinned(tripId: number): boolean {
    return this.pinnedTripsService.isTripPinned(tripId);
  }


  /**
   * Limpia todos los viajes pineados
   */
  public clearAllPinnedTrips(): void {
    this.pinnedTripsService.clearAllPinnedTrips();
  }

  /**
   * Abre el modal de configuración de viajes pineados
   */
  public openPinnedTripsModal(): void {
    const modalData: PinnedTripsConfigData = {
      currentMode: this.showOnlyPinned ? 'pinned-only' : 'all',
      pinnedCount: this.pinnedTripIds.size
    };

    const dialogRef = this.dialog.open(PinnedTripsConfigModalComponent, {
      width: '95%',
      maxWidth: '600px',
      data: modalData
    });

    dialogRef.afterClosed().subscribe((result: PinnedTripsConfigResult) => {
      if (result) {
        this.handleModalResult(result);
      }
    });
  }

  /**
   * Maneja el resultado del modal de configuración
   */
  private handleModalResult(result: PinnedTripsConfigResult): void {
    const showOnlyPinned = result.mode === 'pinned-only';

    // Si se limpiaron todos los viajes pineados, refrescar la vista
    if (result.clearedAll) {
      this.showOnlyPinned = false;
      this.pinnedTripsService.setViewMode(false);
      // Refrescar todos los viajes desde la API
      this.fetchAllWithCount(50, 1, null);
    }else{
      this.changeViewMode(showOnlyPinned);
    }
  }

  /**
   * Cambia el modo de visualización y actualiza la vista
   */
  public changeViewMode(showOnlyPinned: boolean): void {
    this.showOnlyPinned = showOnlyPinned;

    // Guardar estado en localStorage
    this.pinnedTripsService.setViewMode(showOnlyPinned);

    if (showOnlyPinned) {
      if (this.pinnedTripIds.size === 0) {
        this.showOnlyPinned = false;
        this.pinnedTripsService.setViewMode(false);
        return;
      }

      // Verificar si estamos en modo árbol o paginación normal
      if (this.modeTreeMonitor === 'statusTrip' || this.modeTreeMonitor === 'functionTrip') {
        // Modo árbol: refrescar datos del árbol con filtro de pineados
        this.fetchAllDataForTree();
      } else {
        // Modo normal: refrescar los viajes pineados desde la API
        this.loadPinnedTrips();
      }
    } else {
      // Verificar si estamos en modo árbol o paginación normal
      if (this.modeTreeMonitor === 'statusTrip' || this.modeTreeMonitor === 'functionTrip') {
        // Modo árbol: recargar datos del árbol completo
        this.fetchAllDataForTree();
      } else {
        // Modo normal: recargar datos normales desde la API
        this.fetchAllWithCount(50, 1, null);
      }
    }
  }
}
